"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentNameAssign = exports.contentInfoSeperator = exports.contentInfoText = exports.contentName = exports.root = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var root = function root() {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("padding:8px;width:400px;box-sizing:border-box;background-color:", _themeConfig.default.color.dark.earth, ";display:flex;")
  );
};

exports.root = root;
var contentName =
/*#__PURE__*/
(0, _emotion.css)("line-height:1.33 !important;font-weight:500;");
exports.contentName = contentName;
var contentInfoText =
/*#__PURE__*/
(0, _emotion.css)("line-height:1.6;");
exports.contentInfoText = contentInfoText;
var contentInfoSeperator =
/*#__PURE__*/
(0, _emotion.css)("padding:0px 6px;");
exports.contentInfoSeperator = contentInfoSeperator;
var contentNameAssign =
/*#__PURE__*/
(0, _emotion.css)("line-height:1.5 !important;");
exports.contentNameAssign = contentNameAssign;